import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { Page } from 'src/app/classes/Page';
import {environment} from '../../../environments/environment';
import {UserNotification} from '../../classes/UserNotification';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root',
})
export class UserNotificationService {

  constructor(private httpClient: HttpClient) { }

  public getAllUserNotifications(pageNumber: number, pageSize: number): Observable<Page<UserNotification>> {
    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: new HttpParams().append('page', pageNumber).append('size', pageSize)
    };
    return this.httpClient.get<Page<UserNotification>>(`${environment.backendApiUrl}/v1/user/notifications`, options);
  }
}
